


































import {
  defineComponent,
  ref,
  watch,
} from '@vue/composition-api';
import { useFormat, useRouter } from '@ideavivat/vivat-2';
// import _ from 'lodash';

// import {} from '@/api';

import ChatBox from '@/components/Chat/Chatbox.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import {
  deleteChats,
  getChatAsCSV,
} from '@/api/index';

const Agenda = defineComponent({
  components: {
    ChatBox,
    CommonModalWithPreset,
  },
  setup(props: any, { emit }) {
    const { route, router } = useRouter();
    const forcedRerender = ref(true);
    const deleteItemsModal = ref(null);
    const downloadReport = async () => {
      await getChatAsCSV(null, route.value.params.liveId);
    };

    const clearChat = async () => {
      (deleteItemsModal.value as any).compose({ entity: 'ลบแชททั้งหมด' });
    };
    const deleteChatsAction = async () => {
      const result = await deleteChats(route.value.params.liveId);
      // if (result === 200) {}
    };

    watch(() => route.value.params.liveId, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        forcedRerender.value = false;
        forcedRerender.value = true;
      }
    });

    return {
      deleteItemsModal,
      downloadReport,
      clearChat,
      deleteChatsAction,
      forcedRerender,
    };
  },
});

export default Agenda;
